import { useMutation } from 'react-query';

import { transformListName } from 'modules/ai/nba/utils/transformList';
import { ApiResponse, ApiError, post } from 'services/api';

const createList = '/lists';

export type NewListConfig = {
  name: string;
};

export const createListMutation = ({ name }: NewListConfig) => {
  return post(createList, {
    name: transformListName(name),
  });
};
export const useCreateNBAAudienceList = () => {
  return useMutation<ApiResponse<Record<string, any>>, ApiError, NewListConfig>({
    mutationFn: createListMutation,
  });
};
